// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vni12","colBig":"styles_colBig__DnAyA","colSmall":"styles_colSmall__17ZHA","shopifyNameWrapper":"styles_shopifyNameWrapper__2mdgQ"};